import React, { Component } from 'react';
import{
    Container,
    Col,
    Row,
    Table,
    Input,
    Button,
} from 'reactstrap';
/**
 * Used for the Listino Prezzi section. 
 */
export class StimaOrdine extends Component {

    constructor(props) {
        super(props);

        this.toggleModal = this.toggleModal.bind(this);
        

        this.state = {
            modal: false,            
        };

        
    
    }

    
    /**
     * Runs upon initial mount of the /listinoPrezzi path
     */
   

    

    toggleModal = () => {
        this.setState({
            modal: !this.state.modal
        })
    }

   

    /**
     * Renders the page
     */
    render() {

        const titolo = (
            <h5 style={{color: "#011e41", fontWeight: "bold", margin: "0px"}}>Stima Ordine</h5>
        );

        return (
            <Container fluid> 
                <Container className="d-flex align-items-center" fluid> 
                    <Row className="d-flex justify-content-center align-items-center" style={{width: "100%", margin: "0px", padding: "0px"}}>
                        <Col className="d-flex align-items-center justify-content-center" style={{width: "100%", margin: "0px", padding: "0px"}}>
                            {titolo}
                        </Col>
                    </Row>
                </Container>
                <Container className="d-flex align-items-center" fluid>
                        <Row className="d-flex justify-content-center align-items-center" style={{width: "100%", margin: "0px", padding: "0px"}}>
                            <Col className="d-flex align-items-center justify-content-center" style={{width: "100%", margin: "0px", padding: "0px", paddingTop: "5px", paddingBottom: "5px", marginTop: "10px"}}>
                                <Table responsive borderless style={{width: "100%", margin: "0", marginTop: "5px"}}>
                                    <tbody style={{fontSize: "24px"}}>
                                        <tr>
                                        <th style={{ width: "50%", padding: "0", paddingRight: "20px", textAlign: "right" }}>Peso Stimato:  </th>
                                        <td align="left" style={{ padding: "0", paddingLeft: "20px" }}>{this.props.totalQta.toFixed(2)} Kg</td>
                                        </tr>
                                        <tr>
                                            <th style={{width: "50%", padding: "0", paddingRight: "20px", textAlign: "right"}}>Data di Consegna:  </th>
                                            <td align="left" style={{padding: "0", paddingLeft: "20px"}}> 
                                                <Input type="date" name="dataDiConsegna" id="dataDiConsegna" style={{height: "100%", width: "100%", fontSize: "20px", padding: "0", paddingLeft: "5px"}} onChange={this.props.handleOrdineDateChange} value={this.props.ordineDataConsegna}/>
                                            </td>
                                        </tr>
                                        <tr>
                                        <th style={{ width: "50%", padding: "0", paddingRight: "20px", textAlign: "right" }}>Note:  </th>
                                        <td align="left" style={{ padding: "0", paddingLeft: "20px" }}>
                                            <Input type="textarea" id="note" name="note" style={{ height: "100%", width: "100%", fontSize: "20px", padding: "0", paddingLeft: "5px" }} onChange={this.props.handleNoteOrdineChange} value={this.props.noteOrdine}/>
                                        </td>
                                    </tr>
                                    </tbody>
                                </Table>                                    
                            </Col>
                    </Row>                    
                </Container>
                <Container className="d-flex align-items-center" fluid>
                    {this.props.avanzateBtn == true ?
                        <Row className="d-flex justify-content-center align-items-center" style={{ width: "100%", margin: "0px", padding: "0px" }}>
                            <Col className="d-flex align-items-center justify-content-center" style={{ width: "100%", margin: "0px", padding: "0px", paddingTop: "5px", paddingBottom: "5px", marginTop: "10px" }}>
                                <Button type="button" className="text-center" onClick={this.props.toggleAvanzate} style={{ width: '30%', padding: '0px', backgroundColor: "#011e41", fontSize: "20px" }}>
                                    Avanzate
                                </Button>
                            </Col>
                        </Row> : null
                    }
                </Container>
                <Container className="d-flex align-items-center" fluid>
                    <hr align="left" style={{ backgroundColor: "#011e41", margin: "0", width: "100%" }} />
                </Container>
                {this.props.sconti == true ?                    
                    <Row className="d-flex justify-content-center align-items-center" style={{ width: "100%", margin: "0px", padding: "0px" }}>
                        <Col className="d-flex align-items-center justify-content-center" style={{ width: "100%", margin: "0px", padding: "0px" }}>                           
                            <Button type="radio" style={{ width: '30%', padding: '2px', backgroundColor: "#011e41", fontSize: "20px" }} disabled={!this.props.sconto40Btn} onClick={this.props.handleNessuno}> Nessuno</Button>
                            <Button type="radio" style={{ width: '30%', padding: '2px', backgroundColor: "#011e41", fontSize: "20px" }} disabled={!this.props.sconto40Btn} onClick={this.props.handleSconto40}>Sconto 40kg</Button>
                            <Button type="radio" style={{ width: '30%', padding: '2px', backgroundColor: "#011e41", fontSize: "20px" }} disabled={!this.props.sconto80Btn} onClick={this.props.handleSconto80}>Sconto 80kg</Button>
                        </Col>
                    </Row> : null
                 }               
            </Container>
        )
    }
}

//VISUALIZZAZIONE SCONTI 40-80Kg

/*{this.props.sconto40Btn == true?
<tr>
    <th style={{ width: "50%", padding: "0", paddingRight: "20px", textAlign: "right" }}>Sconto 40Kg: </th>
    <td align="left" style={{ padding: "0", paddingLeft: "20px" }}>-€ {(this.props.totalStima - this.props.sconto40).toFixed(2)} -- {this.props.applicato40}</td>
</tr> : null
                                    }

<tr>
    <th style={{ width: "50%", padding: "0", paddingRight: "20px", textAlign: "right" }}>Sconto 80Kg: </th>
    <td align="left" style={{ padding: "0", paddingLeft: "20px" }}>-€ </td>
</tr>



<tr>
                                            <th style={{width: "50%", padding: "0", paddingRight: "20px", textAlign: "right"}}>Stima:  </th>
                                            <td align="left" style={{padding: "0", paddingLeft: "20px"}}> € {this.props.totalStima.toFixed(2)}</td>
                                        </tr>                                    
                                        <tr>
                                            <th style={{height: "2px", width: "50%", padding: "0", textAlign: "right"}}><hr align="right" style={{backgroundColor: "#011e41", marginTop: "0", marginBottom: "0", width:"100%"}}/> </th>
                                            <td align="left" style={{height: "2px", padding: "0"}}><hr align="left" style={{backgroundColor: "#011e41", margin: "0", width:"100%"}}/></td>
                                        </tr>
                                        <tr>
                                        <th style={{ width: "50%", padding: "0", paddingRight: "20px", textAlign: "right" }}>Totale:  </th>
                                        {this.props.applicato40 == true ?
                                            <td align="left" style={{ padding: "0", paddingLeft: "20px" }}> € {this.props.sconto40.toFixed(2)}<sup>*sconto 40Kg</sup></td> :
                                            this.props.applicato80 == true?
                                                <td align="left" style={{ padding: "0", paddingLeft: "20px" }}> € {this.props.sconto80.toFixed(2)}<sup>*sconto 80Kg</sup></td> :
                                                <td align="left" style={{ padding: "0", paddingLeft: "20px" }}> € {this.props.totalStimaAfterSconti.toFixed(2)}</td>
                                        }
                                        </tr>
*/


// WEBPACK FOOTER //
// ./src/components/NuovoOrdine/StimaDeposito.js